
export const TeamAPI = {};

const SLICE = 'team';

TeamAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/team`,
    method:   'POST',
    data:     data,
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TeamAPI.delete = (ids, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/team`,
    method:    'DELETE',
    data:      {ids},
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TeamAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/team`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TeamAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/teams`,
    method:    'GET',
    data:      data,
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TeamAPI.item = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/team`,
    method:    'GET',
    data:      {id},
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

TeamAPI.import = (file, onSuccess, onFailure) => {
  return {
    type: 'API',
    url: `/stream/teams/import`,
    method: 'POST',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    slice: SLICE,
    action: 'import',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};